import angular, { ILogService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'

class LoginMainComponentCtrl {
  // empresa!: string
  seccionCuestionarios!: boolean

  form = {
    username: '',
    pass: '',
    recapResponse: null as unknown,
  }

  errorcapt = false // si no se marca el catpcha

  private recaptchaACTIVO = false

  private closeWindow = false

  constructor(
    private $log: ILogService,
    private $timeout: angular.ITimeoutService,
    private $state: angular.ui.IStateService,
    private vcRecaptchaService: any,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[LoginMainComponentCtrl] onInit')
  }

  gologin() {
    // this.vcRecaptchaService.execute();

    this.$log.info('login', this.form)

    if (this.recaptchaACTIVO && !this.validaRecaptcha()) {
      return
    }

    let pet = {
      username: this.form.username,
      pass: this.form.pass,
      verify: this.form.recapResponse as string,
      ip: undefined as string,
    }

    this.AccesoDatos.Login_CLIENT.login(pet) //
      .then((appstateResponse) => {
        const _goBack = window.location.href.includes('_back=1')

        if (_goBack) {
          this.closeWindow = true

          window.close()
          return
        }

        if (this.seccionCuestionarios) {
          this.$state.go('cuestionarios.priv.startpriv')
        } else if (appstateResponse.adm) {
          this.$state.go('priv.main')
        } else {
          this.$state.go('priv.main.myforms')
        }
      })
  }

  testClose() {
    this.closeWindow = true

    try {
      window.close()
    } catch (err) {
      this.$log.error('Error cerrando ventana', err)
    }
  }

  private validaRecaptcha() {
    var recapResponse = this.vcRecaptchaService.getResponse() // returns the string response

    if (recapResponse == '') {
      this.errorcapt = true
      return false
    }

    this.$log.info('recaptcha', recapResponse)

    return true
  }
}

angular.module('candidato').component('loginMain', {
  bindings: {
    // empresa: "<",
    seccionCuestionarios: '<',
  },
  controller: LoginMainComponentCtrl,
  // templateUrl: "login-main.component.html",
  template: require('./login-main.component.html'),
})
